import React from 'react';
import { Typography } from 'src/components/PulseUI';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';

const NoDataAvailable = () => {
  return (
    <div className="w-full h-60 flex flex-col items-center justify-center gap-2">
      <Icon icon={faCircleExclamation} size="2x" color="#9FA6AD" />
      <Typography
        variant="body1"
        align="center"
        className="text-[#636B74]"
      >
        No data available
      </Typography>
    </div>
  );
};

export default NoDataAvailable;
